export default [
  {
    path: '/dashboard/isp',
    name: 'dashboard-ecommerce',
    component: () => import('@/views/isp/dashboard/ecommerce/Ecommerce.vue'),
  },
]
